import { useWorkflowChrome } from '../components/Layout/WorkflowChromeContext';
import { usePeriodRefresh } from './usePeriodRefresh';

/**
 * Keeps the stepper in near-real-time for the period the chrome shows. Replaces the periodic
 * polling that previously lived inside `useWorkflowStages`.
 *
 * Designed to be mounted once at the chrome level (inside `WorkflowChromeProvider`) — every page
 * that consumes the stepper benefits without each page wiring its own listener.
 */
export const useWorkflowChromeStatusSync = (): void => {
  const { periodId, workflowId } = useWorkflowChrome();
  usePeriodRefresh(periodId, workflowId);
};
